var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box } from '@chakra-ui/react';
import DefaultUpload from 'src/core/assets/images/default-upload.jpg';
export var ImageBox = function (props) {
    var src = props.src, width = props.width, height = props.height, rest = __rest(props, ["src", "width", "height"]);
    return (_jsx(Box, __assign({ width: width, height: height || width, borderColor: "gray.100", borderStyle: "solid", flexShrink: 0, bgSize: "contain", bgColor: "#fff", bgPosition: "center", bgRepeat: "no-repeat", bgImage: "url(".concat(src ? src : DefaultUpload, ")"), borderRadius: 6 }, rest), void 0));
};
ImageBox.defaultProps = {
    width: '40px',
};
